// src/AssessmentContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config';


const AssessmentContext = createContext();

export function AssessmentProvider({ children }) {
  const [assessmentData, setAssessmentData] = useState([]);
  const [loadingAssessment, setLoadingAssessment] = useState(false);

  
  const fetchData = async () => {
    try {
      setLoadingAssessment(true);
      const response = await fetch(`${config.apiBaseUrl}/assessment/getAssessments.php`);
      
      const data = await response.json();
      setAssessmentData(data);
    } catch (error) {
      console.error('Error fetching fee data:', error);
    } finally {
      setLoadingAssessment(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const loadAssessmentData = () => {
    fetchData();
  };

  // console.log(assessmentData);

  return (
    <AssessmentContext.Provider value={{ assessmentData, loadingAssessment, loadAssessmentData }}>
      {children}
    </AssessmentContext.Provider>
  );
}

export function useAssessmentData() {
  const context = useContext(AssessmentContext);
  if (context === undefined) {
    throw new Error('useAssessmentData must be used within a AssessmentProvider');
  }
  return context;
}
